import React from "react";
import ReactDOM from "react-dom";
import trackEvent from "../util/trackEvent";
import QuantityInput from "../react/components/QuantityInput.jsx";
import { showTab } from "../components/tabs";


const urlParams = new URLSearchParams(window.location.search);
const urlQueryStringKey = "catNum";
const catalogNumber = urlParams.get(urlQueryStringKey);
const productState = {
	catalogNumber,
	pageConfiguration: null,
	currentQuantity: 1,
	primaryValues: null,
};

const updateState = (key, value) => {
	productState[key] = value;
};

const trackAddToCartButtonClick = (event) => {
	const eventSource = event.target.closest(".product-sticky-selection")
		? "Sticky header"
		: "Inline";
	trackEvent("Components", "Product purchase - clicked Add to Cart", eventSource);
};

const trackOptionChange = (event) => {
	const eventSource = event.target.closest(".modal-dialog") ? "Modal" : "Inline";
	trackEvent("Components", "Product purchase - selected an option", eventSource);
};

const setupCartTracking = () => {
	const cartButtons = document.querySelectorAll("[id^='AddToCart']");
	if (cartButtons.length > 0) {
		for (let i = 0; i < cartButtons.length; i++) {
			const currentCartBtn = cartButtons[i];
			currentCartBtn.addEventListener("click", trackAddToCartButtonClick);
		}
	}
};

const displayMatchingImage = (productSelection) => {
	const productImages = document.querySelectorAll(".product_image");

	productImages.forEach((image) => {
		image.classList.add("hidden-from-display");
	});

	const productImage = document.getElementById("ProductImage" + escapeId(productSelection.toUpperCase()));
	if (productImage != null) {
		productImage.classList.remove("hidden-from-display");
	}
};

const determinePageConfiguration = () => {
	const productSelectionGrid = document.querySelector(".product-selection__grid");
	const productSelectionTable = document.querySelector(".product-selection__table");
	if (productSelectionGrid) {
		updateState("pageConfiguration", "tile");
	} else if (productSelectionTable) {
		updateState("pageConfiguration", "table");
	} else {
		updateState("pageConfiguration", "tile");
	}
};

const initialProductSelection = (catalogNumber, primaryOptions, secondaryOptions) => {
	const primaryOptionsElements = document.getElementsByName(primaryOptions);
	const secondaryOptionsElements = document.getElementsByName(secondaryOptions);

	if (primaryOptionsElements.length === 0) {
		return;
	}

	const primaryOptionsArray = Array.from(primaryOptionsElements);
	const secondaryOptionsArray = Array.from(secondaryOptionsElements);

	let selectedPrimaryOption;

	if (catalogNumber) {
		selectedPrimaryOption = primaryOptionsArray.find((option) =>
			option.value.split(",").includes(catalogNumber)
		);
		if (!selectedPrimaryOption) {
			selectedPrimaryOption = primaryOptionsArray[0];
			// Also clear the invalid query string
			updateQueryString(primaryOptionsArray[0].value.split(",")[0]);
		}
	} else {
		// First load - no cat num, select first primary option
		selectedPrimaryOption = primaryOptionsArray[0];
	}

	selectedPrimaryOption.checked = true;
	updateState("primaryValues", selectedPrimaryOption.value);

	if (secondaryOptionsArray.length > 0) {
		const primaryValues = selectedPrimaryOption.value.split(",");
		secondaryOptionsArray.forEach((option) => {
			const optionValues = option.value.split(",");
			option.disabled = !optionValues.some((value) => primaryValues.includes(value));
		});
		if (catalogNumber) {
			for (let secondaryOption of secondaryOptionsArray) {
				if (!secondaryOption.disabled) {
					const secondaryValues = secondaryOption.value.split(",");
					if (secondaryValues.includes(catalogNumber)) {
						if (secondaryOption.type === "checkbox" || secondaryOption.type === "radio") {
							secondaryOption.checked = true;
							secondaryOption.dispatchEvent(new Event("change", { bubbles: true }));
						}
						if (secondaryOption.tagName === "OPTION") {
							secondaryOption.parentElement.value = secondaryOption.value;
							secondaryOption.dispatchEvent(new Event("change", { bubbles: true }));
						}
						return;
					}
				}
			}
		} else {
			const firstSecondaryOption = secondaryOptionsArray[0];
			if (firstSecondaryOption.type === "checkbox" || firstSecondaryOption.tagName === "OPTION") {
				updateState("catalogNumber", selectedPrimaryOption.value.split(",")[0]);
			} else {
				firstSecondaryOption.checked = true;
				firstSecondaryOption.dispatchEvent(new Event("change", { bubbles: true }));
				const primaryValues = selectedPrimaryOption.value.split(",");
				const secondaryValues = firstSecondaryOption.value.split(",");

				const matchingValue = secondaryValues.find((secondaryValue) =>
					primaryValues.includes(secondaryValue)
				);
				if (matchingValue) {
					updateState("catalogNumber", matchingValue);
				}
				else {
					firstSecondaryOption.checked = false;
					firstSecondaryOption.dispatchEvent(new Event("change", { bubbles: true }));
					updateState("catalogNumber", selectedPrimaryOption.value);
                }
			}
		}
	} else {
		updateState("catalogNumber", selectedPrimaryOption.value);
	}
};

const handlePrimaryClick = (values, event) => {
	const secondaryOptionsElements = document.getElementsByName("product-selection--secondary");
	const secondaryOptionsArray = Array.from(secondaryOptionsElements);
	updateState("primaryValues", values);
	trackOptionChange(event);

	if (secondaryOptionsArray.length > 0) {
		const primaryValues = values.split(",");
		secondaryOptionsArray.forEach((option) => {
			const optionValues = option.value.split(",");

			if (option.type === "checkbox") {
				option.checked = false;
			}
			if (
				option.tagName === "OPTION" &&
				option.parentElement &&
				option.parentElement.tagName === "SELECT"
			) {
				option.parentElement.value = "none";
			}

			option.disabled = !optionValues.some((value) => primaryValues.includes(value));
		});

		const firstSecondaryOption = secondaryOptionsArray.find((option) => !option.disabled);
		if (firstSecondaryOption) {
			if (firstSecondaryOption.type === "checkbox" || firstSecondaryOption.tagName === "OPTION") {
				updateState("catalogNumber", values.split(",")[0]);
			} else {
				firstSecondaryOption.checked = true;
				firstSecondaryOption.dispatchEvent(new Event("change", { bubbles: true }));
				const primaryValues = values.split(",");
				const secondaryValues = firstSecondaryOption.value.split(",");

				const matchingValue = secondaryValues.find((secondaryValue) =>
					primaryValues.includes(secondaryValue)
				);
				if (matchingValue) {
					updateState("catalogNumber", matchingValue);
				} else {
					firstSecondaryOption.checked = false;
					firstSecondaryOption.dispatchEvent(new Event("change", { bubbles: true }));
					updateState("catalogNumber", values.split(",")[0]);
				}
			}
		} else {
			secondaryOptionsArray.forEach(function (secondaryOption) {
				secondaryOption.checked = false;
				secondaryOption.dispatchEvent(new Event("change", { bubbles: true }));
			});
			updateState("catalogNumber", primaryValues[0]);
		}
	} else {
		updateState("catalogNumber", values.split(",")[0]);
	}
	displayMatchingImage(productState.catalogNumber);
	displayMatchingCommerce(productState.catalogNumber);
	displayMatchingSpecTab(productState.catalogNumber);
	updateQueryString(productState.catalogNumber);
	updateOtherPriceDisplay(productState.catalogNumber);
	updateState("currentQuantity", 1);
};

const handleSecondaryClick = (element, elementType, event) => {
	const primaryValuesArray = productState.primaryValues.split(",");
	let newCatalogNumber = "";
	trackOptionChange(event);

	if (elementType === "select") {
		const selectedValues = element.value.split(",");
		const matchingValue = selectedValues.find((value) => primaryValuesArray.includes(value));

		if (matchingValue) {
			newCatalogNumber = matchingValue;
		} else {
			newCatalogNumber = primaryValuesArray[0];
		}
	} else if (elementType === "checkbox") {
		if (element.checked) {
			const matchedValue = element.value
				.split(',')
				.map(val => val.trim())
				.find(val => primaryValuesArray.includes(val));
			if (matchedValue) {
				newCatalogNumber = matchedValue;
            }
		} else {
			newCatalogNumber = primaryValuesArray[0];
		}
	} else {
		const selectedValues = element.value.split(",");
		const matchingValue = selectedValues.find((value) => primaryValuesArray.includes(value));

		if (matchingValue) {
			newCatalogNumber = matchingValue;
		} else {
			newCatalogNumber = primaryValuesArray[0];
		}
	}

	if (newCatalogNumber) {
		updateState("catalogNumber", newCatalogNumber);
		displayMatchingImage(productState.catalogNumber);
		displayMatchingCommerce(productState.catalogNumber);
		displayMatchingSpecTab(productState.catalogNumber);
		updateQueryString(productState.catalogNumber);
		updateOtherPriceDisplay(productState.catalogNumber);
		updateState("currentQuantity", 1);
	}
};

const setupSecondarySelection = (secondarySelections) => {
	const secondaryOptions = document.getElementsByName(secondarySelections);

	for (const secondaryOption of secondaryOptions) {
		if (secondaryOption.tagName === "OPTION") {
			const parentSelect = secondaryOption.closest("select");
			if (parentSelect) {
				parentSelect.addEventListener("change", function (event) {
					handleSecondaryClick(parentSelect, "select", event);
				});
				break;
			}
		} else if (secondaryOption.type === "checkbox") {
			secondaryOption.addEventListener("change", function (event) {
				handleSecondaryClick(this, "checkbox", event);
			});
		} else {
			secondaryOption.addEventListener("change", function (event) {
				handleSecondaryClick(this, "tile", event);
			});
		}
	}
};

const setupPrimarySelection = (primarySelections) => {
	const primaryOptions = document.getElementsByName(primarySelections);
	if (primaryOptions.length > 0) {
		primaryOptions.forEach((primaryOption) => {
			primaryOption.addEventListener("click", function (event) {
				handlePrimaryClick(this.value, event);
			});
		});
	}
};

function escapeId(id) {
	return id.replace(/ /g, '-');
}


const displayMatchingCommerce = (catalogNumber) => {
	const commerceElements = document.querySelectorAll("[id^='AddToCart']");

	if (commerceElements.length > 0) {
		commerceElements.forEach((commerceElement) => {
			commerceElement.classList.add("hidden-from-display");
		});

		const safeCatalogNumber = escapeId(catalogNumber.toUpperCase());
		const currentCommerceElement = document.querySelector(`[id^='AddToCart${safeCatalogNumber}']`);

		if (currentCommerceElement != null) {
			currentCommerceElement.classList.remove("hidden-from-display");
		}
	}
};

const updateQueryString = (catalogNumber) => {
	const url = new URL(window.location.href);
	url.searchParams.set(urlQueryStringKey, catalogNumber);

	history.replaceState(null, "", url.toString());
};

const updateCartUrl = (catalogNumber) => {
	const currentQuantity = productState.currentQuantity;
	const safeCatalogNumber = escapeId(catalogNumber.toUpperCase());
	const selector = `[id^='AddToCart${safeCatalogNumber}'] a.product-purchase__buttons`;
	const currentAddToCart = document.querySelector(selector);

	if (currentAddToCart) {
		const urlObj = new URL(currentAddToCart.href);
		urlObj.searchParams.set("qty", currentQuantity);
		currentAddToCart.href = urlObj.href;
	}
};


const displayMatchingSpecTab = (catalogNumber) => {
	const productSpecTab = document.getElementById(
		"ProductSpecification" + escapeId(catalogNumber.toUpperCase())
	);

	const productSpecDiv = document.querySelector("div[id^='ProductSpecification'].display-as-block");

	if (productSpecDiv) {
		productSpecDiv.classList.add("hidden-from-display");
		productSpecDiv.classList.remove("display-as-block");
	}

	if (productSpecTab) {
		productSpecTab.classList.add("display-as-block");
		productSpecTab.classList.remove("hidden-from-display");

		const productSpecTabCatDisplay = productSpecTab.parentElement.querySelector(".catalog-number");
		if (productSpecTabCatDisplay) {
			productSpecTabCatDisplay.textContent = catalogNumber.toUpperCase();
		}
	}
};

const updateOtherPriceDisplay = (catalogNumber) => {
	const productSelectionElement = document.querySelector(
		".product-info-container .product-catalog-number .catalog-number"
	);

	const safeCatalogNumber = escapeId(catalogNumber.toUpperCase());
	const productPrice = document.querySelector(
		`[id^='AddToCart${safeCatalogNumber}'] .product-price`
	);
	const productPriceElement = document.querySelector(".product-info-container .product-price");
	if (productPrice) {
		if (productSelectionElement && productPriceElement) {
			productPriceElement.classList.remove("hidden-from-display");
			productPriceElement.classList.add("display-as-block");
			productSelectionElement.textContent = catalogNumber.toUpperCase();
			productPriceElement.textContent = productPrice.textContent;
		}
	} else {
		if (productSelectionElement) {
			productSelectionElement.textContent = catalogNumber.toUpperCase();
			productPriceElement.classList.add("hidden-from-display");
		}
	}
};

const initialPageLoad = () => {
	const pageType = productState.pageConfiguration;
	if (pageType === "tile") {
		initialProductSelection(
			productState.catalogNumber,
			"product-selection--primary",
			"product-selection--secondary"
		);
		displayMatchingImage(productState.catalogNumber);
		displayMatchingCommerce(productState.catalogNumber);
		displayMatchingSpecTab(productState.catalogNumber);
		updateOtherPriceDisplay(productState.catalogNumber);
		setupPrimarySelection("product-selection--primary");
		setupSecondarySelection("product-selection--secondary");
		renderQuantityInput(handleChange);
		setupCartTracking();
	}
	if (pageType === "table") {
		checkForDisclaimers();
		processTableRows(".table-row");
		initialProductSelection(
			productState.catalogNumber,
			"product-selection--primary",
			"product-selection--secondary"
		);
		displayMatchingImage(productState.catalogNumber);
		displayMatchingSpecTab(productState.catalogNumber);
		setupCartTracking();
	}
};

/**
 * Sets visual styles for the selected table row
 *
 * @param {string} element - The selected table row.
 */
const setRowStyles = (element) => {
	const catalogNo = element.querySelector(".catalog-number");
	const productName = element.querySelector(".product-name");
	const productSize = element.querySelector(".product-size");

	element.style.backgroundColor = "#fcf8e3";
	catalogNo.style.fontWeight = "bold";
	productName.style.fontWeight = "bold";
	productSize.style.fontWeight = "bold";
};

/**
 * Resets visual styles for all table rows
 */
const resetRowStyles = () => {
	const rows = document.querySelectorAll(".table-row");
	if (rows.length > 0) {
		rows.forEach((row) => {
			row.style.backgroundColor = "";
			row.querySelector(".catalog-number").style.fontWeight = "normal";
			row.querySelector(".product-name").style.fontWeight = "normal";
			row.querySelector(".product-size").style.fontWeight = "normal";
		});
	}
};

const handleTabSelection = (tabContainer) => {
	const tabName = 'specifications';

	showTab(tabName, tabContainer, { skipQueryStringUpdate: true });

	const urlParams = new URLSearchParams(window.location.search);
	urlParams.set('tabset0', '2');
	const newUrl = `${window.location.pathname}?${urlParams.toString()}${window.location.hash}`;
	history.pushState(null, null, newUrl);
};

const handleRowClick = (event, row, radioBtn) => {
	resetRowStyles();

	if (radioBtn) {
		radioBtn.checked = true;
		setRowStyles(row);
		updateState("catalogNumber", radioBtn.value);
		updateQueryString(productState.catalogNumber);
		displayMatchingImage(productState.catalogNumber);
		displayMatchingSpecTab(productState.catalogNumber);
	}

	if (event.target.tagName === "A") {

		// View Specifications Link
		if (event.target.classList.contains("product-view__specifications-link")) {
			event.preventDefault();

			const specificationsTab = document.querySelector('.content-container--tabs');
			if (specificationsTab) {
				handleTabSelection(specificationsTab);
            }
		}

		// Add to Cart Button link
		if (event.target.classList.contains("product-purchase__cart")) {
			const qtyInput = row.querySelector(".product-purchase__qty");
			let qtyValue = qtyInput ? qtyInput.value.trim() : "";

			if (qtyValue !== "" && (isNaN(parseInt(qtyValue)) || parseInt(qtyValue) <= 0)) {
				event.preventDefault();
			} else {
				if (qtyValue === "") {
					qtyValue = 1;
				}
				let currentHref = event.target.getAttribute("href");
				let newHref = updateHrefWithQuantity(currentHref, qtyValue);
				event.target.setAttribute("href", newHref);
				window.location.href = event.target.href;
			}
		}
	}
}

const handleQuantityFocus = (row, radioBtn) => {
	resetRowStyles();

	if (radioBtn) {
		radioBtn.checked = true;
		const selectedPrimaryOption = radioBtn;
		setRowStyles(row);
		updateState("catalogNumber", selectedPrimaryOption.value)
		updateQueryString(productState.catalogNumber);
		displayMatchingImage(productState.catalogNumber);
		displayMatchingSpecTab(productState.catalogNumber);
	}
};

const updateHrefWithQuantity = (href, qtyValue) => {
	const param = "&qty=" + qtyValue;
	return href.includes("&qty=") ? href.replace(/&qty=\d+/, param) : href + param;
}

const checkForDisclaimers = () => {
	const tableContainers = document.querySelectorAll(".product-selection__table-container");
	tableContainers.forEach((container) => {
		const productTable = container.querySelector(".product-selection__table");
		if (productTable) {
			let earlyAccessLabel = productTable.querySelector(".label--early-access");
			let catalogFtLabel = productTable.querySelector(".label--fast-track");

			if (earlyAccessLabel) {
				let earlyAccessDisclaimer = container.querySelector(".early-access--disclaimer");
				if (earlyAccessDisclaimer) {
					earlyAccessDisclaimer.style.display = "block";
				}
			}

			if (catalogFtLabel) {
				let catalogFtDisclaimer = container.querySelector(".catalog-ft--disclaimer");
				if (catalogFtDisclaimer) {
					catalogFtDisclaimer.style.display = "block";
				}
			}
		}
	});
};

const processTableRows = (tableRowClassname) => {
	const tableRows = document.querySelectorAll(tableRowClassname);
	const preSelectedProduct = productState.catalogNumber;

	if (tableRows.length > 0) {
		const applyRowListeners = (row) => {
			const productCatalogNo = row.getAttribute("data-catalog-number");
			const radioBtn = row.querySelector(".product-selection__option-control");
			const quantityInput = row.querySelector(".product-purchase__qty");
			const addToCartBtn = row.querySelector(".product-purchase__cart");

			// Add event listener for row click
			row.addEventListener("click", (event) =>
				handleRowClick(event, row, radioBtn)
			);

			// Add focus event listener for quantity input
			if (quantityInput) {
				quantityInput.addEventListener("focus", () => handleQuantityFocus(row, radioBtn));
			}
		};

		// Check if there's a pre-selected product
		if (!preSelectedProduct) {
			const firstRow = tableRows[0];
			setRowStyles(firstRow);
			applyRowListeners(firstRow);
		}

		// Process all rows and check for preSelectedProduct
		tableRows.forEach((row) => {
			const productCatalogNo = row.getAttribute("data-catalog-number");

			if (productCatalogNo === preSelectedProduct) {
				setRowStyles(row);
			}

			applyRowListeners(row);
		});
	}
};


const handleChange = (value) => {
	updateState("currentQuantity", value);
	updateCartUrl(productState.catalogNumber);
};

/**
 * Renders and hydrates the quantity input components in the specified placeholders with the given new value.
 * Updates the cart URL after rendering if quantity input placeholders are present.
 */
const renderQuantityInput = (changeFunction) => {
	const qtyPlaceholders = document.querySelectorAll(".quantity-input");
	for (let i = 0; i < qtyPlaceholders.length; i++) {
		const qtyPlaceholder = qtyPlaceholders[i];
		if (qtyPlaceholder) {
			ReactDOM.render(
				React.createElement(QuantityInput, {
					onValueChange: changeFunction,
					min: productState.currentQuantity,
					max: 999,
				}),
				qtyPlaceholder.parentElement
			);
		}
	}
};

document.addEventListener("DOMContentLoaded", (event) => {
	determinePageConfiguration();
	initialPageLoad();
});
